"use strict";
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unused-vars */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonConnect = exports.TonConnectService = void 0;
const protocol_1 = require("@tonconnect/protocol");
const axios_1 = __importDefault(require("axios"));
const storage_1 = require("../storage");
const config_1 = require("./config");
const ConnectEventError_1 = require("./ConnectEventError");
const models_1 = require("./models");
const EventID_1 = require("./EventID");
const ConnectReplyBuilder_1 = require("./ConnectReplyBuilder");
const SendTransactionError_1 = require("./SendTransactionError");
function getTimeSec() {
    return Math.floor(Date.now() / 1000);
}
class TonConnectService {
    constructor() {
        // this._storage = WebAppSDK.initData.length !== 0 && !(WebAppSDK.platform === 'macos')
        //     ? new TelegramStorage()
        //     : new StorageWallet()
        this._browser_storage = new storage_1.StorageWallet();
    }
    // private store: Main
    // constructor (store: Main) {
    //     this.store = store
    // }
    checkProtocolVersionCapability(protocolVersion) {
        if (typeof protocolVersion !== 'number' || protocolVersion < config_1.MIN_PROTOCOL_VERSION) {
            throw new ConnectEventError_1.ConnectEventError(protocol_1.CONNECT_EVENT_ERROR_CODES.BAD_REQUEST_ERROR, `Protocol version ${String(protocolVersion)} is not supported by the wallet app`);
        }
    }
    verifyConnectRequest(request) {
        if (!(request && request.manifestUrl && request.items?.length)) {
            throw new ConnectEventError_1.ConnectEventError(protocol_1.CONNECT_EVENT_ERROR_CODES.BAD_REQUEST_ERROR, 'Wrong request data');
        }
    }
    async fetchFromProxy(manifestUrl) {
        const response = await axios_1.default.get('https://manifest-proxy.delab.team/manifest', { params: { url: manifestUrl } });
        return response.data;
    }
    async getManifest(request) {
        try {
            console.log('request.manifestUrl', request.manifestUrl);
            console.log('START axios.get<DAppManifest>(request.manifestUrl)', request.manifestUrl);
            // const { data: manifest } = await axios.get<DAppManifest>(request.manifestUrl)
            const manifest = await this.fetchFromProxy(request.manifestUrl);
            console.log('FINISH manifest', manifest);
            const isValid = manifest
                && typeof manifest.url === 'string'
                && typeof manifest.name === 'string'
                && typeof manifest.iconUrl === 'string';
            if (!isValid) {
                throw new ConnectEventError_1.ConnectEventError(protocol_1.CONNECT_EVENT_ERROR_CODES.MANIFEST_CONTENT_ERROR, 'Manifest is not valid');
            }
            return manifest;
        }
        catch (error) {
            if (axios_1.default.isAxiosError(error)) {
                throw new ConnectEventError_1.ConnectEventError(protocol_1.CONNECT_EVENT_ERROR_CODES.MANIFEST_NOT_FOUND_ERROR, `Can't get ${request.manifestUrl}`);
            }
            throw error;
        }
    }
    // test (store: any) {
    //     // const { storeMain } = useStores()
    //     // storeMain.setTonConnectModalOpen(true)
    //     // const storeMainRepository = useStoreNanoStores(storeMain.repository)
    //     // console.log('storeMainRepository.tonConnectModalOpen', storeMainRepository.tonConnectModalOpen)
    //     store.setTonConnectModalOpen(true)
    // }
    async connect(protocolVersion, request, setShowConnectModal, setConnectModalProps, setConnectedApps, connectedApps, sessionCrypto, clientSessionId, webViewUrl) {
        try {
            this.checkProtocolVersionCapability(protocolVersion);
            this.verifyConnectRequest(request);
            const manifest = await this.getManifest(request);
            console.log('manifest', manifest);
            const SetPropsTonconnectModalState = (props) => {
                console.log('SetPropsTonconnectModalState');
                setShowConnectModal(true);
                setConnectModalProps(props);
            };
            try {
                console.log('start try');
                const { replyItems } = await new Promise((resolve, reject) => {
                    SetPropsTonconnectModalState({
                        protocolVersion: protocolVersion,
                        manifest,
                        replyBuilder: new ConnectReplyBuilder_1.ConnectReplyBuilder(request, manifest),
                        requestPromise: { resolve, reject },
                        hideImmediately: !!webViewUrl
                    });
                });
                console.log('replyItems', replyItems);
                const storageConnections = await this.loadConnections();
                console.log('LOAD previous connsection', storageConnections.connections);
                console.log('previous + current', [...storageConnections.connections,
                    {
                        type: models_1.TonConnectBridgeType.Remote,
                        sessionKeyPair: sessionCrypto.stringifyKeypair(),
                        clientSessionId: clientSessionId,
                        replyItems
                    }
                ]);
                setConnectedApps([
                    ...storageConnections.connections,
                    {
                        type: models_1.TonConnectBridgeType.Remote,
                        sessionKeyPair: sessionCrypto.stringifyKeypair(),
                        clientSessionId: clientSessionId,
                        replyItems
                    }
                ]);
                if (storageConnections.connections.length > 0) {
                    const saveResTwo = await this.saveConnections([
                        ...storageConnections.connections,
                        {
                            type: models_1.TonConnectBridgeType.Remote,
                            sessionKeyPair: sessionCrypto.stringifyKeypair(),
                            clientSessionId: clientSessionId,
                            replyItems
                        }
                    ]);
                    console.log('saveResAll in storage res prev.length > 0', saveResTwo);
                }
                if (storageConnections.connections.length === 0) {
                    const saveResOne = await this.saveConnections([
                        {
                            type: models_1.TonConnectBridgeType.Remote,
                            sessionKeyPair: sessionCrypto.stringifyKeypair(),
                            clientSessionId: clientSessionId,
                            replyItems
                        }
                    ]);
                    console.log('saveResOne in storage res prev.length === 0', saveResOne);
                }
                return {
                    id: EventID_1.TCEventID.getId(),
                    event: 'connect',
                    payload: {
                        items: replyItems,
                        device: config_1.tonConnectDeviceInfo
                    }
                };
            }
            catch {
                throw new ConnectEventError_1.ConnectEventError(protocol_1.CONNECT_EVENT_ERROR_CODES.USER_REJECTS_ERROR, 'Wallet declined the request');
            }
        }
        catch (error) {
            if (error instanceof ConnectEventError_1.ConnectEventError) {
                return error;
            }
            return new ConnectEventError_1.ConnectEventError(protocol_1.CONNECT_EVENT_ERROR_CODES.UNKNOWN_ERROR, 'initial connect error');
        }
    }
    saveConnections(connections) {
        const connectedAppsString = JSON.stringify(connections);
        console.log('SAVE CONNECTIONS IN STORAGE', connectedAppsString);
        console.log('SAVE CONNECTIONS IN STORAGE parsed', connections);
        return (this._browser_storage.del('connections') && this._browser_storage.save('connections', connectedAppsString));
    }
    async loadConnections() {
        const rawConnections = await this._browser_storage.get('connections');
        console.log('rawConnections', rawConnections);
        if (!rawConnections || rawConnections === undefined || rawConnections === null || rawConnections === '') {
            console.log('loadConnections undefined case');
            return { connections: [] };
        }
        return { connections: JSON.parse(rawConnections) };
    }
    async handleRequestFromRemoteBridge(request, clientSessionId, connection, setShowSendModal, setTonconnectTransactionProps, setConnectedApps, connectedApps) {
        // const { connectedApp, connection } = findConnectedAppByClientSessionId(clientSessionId)
        return this.handleRequest(request, connection, setShowSendModal, setTonconnectTransactionProps, setConnectedApps, connectedApps);
    }
    async handleRequest(request, connection, setShowSendModal, setTonconnectTransactionProps, setConnectedApps, connectedApps) {
        if (!connection) {
            return {
                error: {
                    code: protocol_1.SEND_TRANSACTION_ERROR_CODES.UNKNOWN_APP_ERROR,
                    message: 'Unknown app'
                },
                id: request.id
            };
        }
        if (request.method === 'sendTransaction') {
            console.log('sendTransaction handle');
            return this.sendTransaction(request, connection, setShowSendModal, setTonconnectTransactionProps);
            // const params = JSON.parse(request.params[0]) as SignRawParams
            // console.log('SSE transaction params', params)
        }
        if (request.method === 'disconnect') {
            return this.handleDisconnectRequest(request, connection, setConnectedApps, connectedApps);
        }
        return {
            error: {
                code: protocol_1.SEND_TRANSACTION_ERROR_CODES.BAD_REQUEST_ERROR,
                message: `Method "${request.method}" does not supported by the wallet app`
            },
            id: request.id
        };
    }
    async handleDisconnectRequest(request, connection, setConnectedApps, connectedApps) {
        const storageConnections = await this.loadConnections();
        if (connection.type === models_1.TonConnectBridgeType.Remote) {
            const remoteConnections = storageConnections.connections.filter(conn => conn.type === models_1.TonConnectBridgeType.Remote);
            const filteredConnections = remoteConnections.filter(conn => conn.clientSessionId !== connection.clientSessionId);
            setConnectedApps(filteredConnections);
            const saveRes = await this.saveConnections(filteredConnections);
            console.log('save in storage res after disconnect', saveRes);
        }
        return {
            id: request.id,
            result: {}
        };
    }
    async sendTransaction(request, connection, setShowSendModal, setTonconnectTransactionProps) {
        try {
            const params = JSON.parse(request.params[0]);
            const isValidRequest = params
                && typeof params.valid_until === 'number'
                && Array.isArray(params.messages)
                && params.messages.every(msg => !!msg.address && !!msg.amount);
            if (!isValidRequest || !params.valid_until) {
                throw new SendTransactionError_1.SendTransactionError(request.id, protocol_1.SEND_TRANSACTION_ERROR_CODES.BAD_REQUEST_ERROR, 'Bad request');
            }
            const { valid_until, messages } = params;
            console.log('tonconnect trans messages', messages);
            if (valid_until < getTimeSec()) {
                throw new SendTransactionError_1.SendTransactionError(request.id, protocol_1.SEND_TRANSACTION_ERROR_CODES.BAD_REQUEST_ERROR, 'Request timed out');
            }
            const SetPropsTonconnectTransaction = (props) => {
                console.log('SetPropsTonconnectTransaction');
                setShowSendModal(true);
                setTonconnectTransactionProps(props);
            };
            console.log('start try');
            console.log('messages from tonconnect transaction', messages);
            const res = await new Promise((resolve, reject) => {
                SetPropsTonconnectTransaction({
                    address: messages[0].address,
                    amount: messages[0].amount,
                    messages,
                    valid_until,
                    requestPromise: { resolve, reject },
                    request
                });
            });
            return {
                result: res,
                id: request.id
            };
        }
        catch (error) {
            if (error instanceof SendTransactionError_1.SendTransactionError) {
                return error;
            }
            return new SendTransactionError_1.SendTransactionError(request.id, protocol_1.SEND_TRANSACTION_ERROR_CODES.UNKNOWN_ERROR, 'UNKNOWN_ERROR');
        }
    }
}
exports.TonConnectService = TonConnectService;
exports.TonConnect = new TonConnectService();
